import * as actionTypes from './vatInfoActionType';

export const getVatInfoRequest = (payload: actionTypes.GetVatInfoRequest): actionTypes.GetVatInfoRequestAction => {
  return {
    type: actionTypes.GET_VAT_INFO_REQUEST,
    payload,
  };
};

export const getVatInfoSuccess = (payload: actionTypes.GetVatInfoResponse): actionTypes.GetVatInfoSuccessAction => {
  return {
    type: actionTypes.GET_VAT_INFO_SUCCESS,
    payload,
  };
};

export const getVatInfoError = (message: string, error?: any): actionTypes.GetVatInfoErrorAction => {
  return {
    type: actionTypes.GET_VAT_INFO_ERROR,
    payload: {
      message,
      error,
    },
  };
};

export const getVatInfoReset = (): actionTypes.GetVatInfoResetAction => {
  return {
    type: actionTypes.GET_VAT_INFO_RESET,
  };
};

export const issueTaxInvoiceRequest = (payload: actionTypes.IssueTaxInvoiceRequest): actionTypes.IssueTaxInvoiceRequestAction => {
  return {
    type: actionTypes.ISSUE_TAX_INVOICE_REQUEST,
    payload,
  };
};

export const issueTaxInvoiceSuccess = (payload: actionTypes.IssueTaxInvoiceResponse): actionTypes.IssueTaxInvoiceSuccessAction => {
  return {
    type: actionTypes.ISSUE_TAX_INVOICE_SUCCESS,
    payload,
  };
};

export const issueTaxInvoiceError = (message: string, error?: any): actionTypes.IssueTaxInvoiceErrorAction => {
  return {
    type: actionTypes.ISSUE_TAX_INVOICE_ERROR,
    payload: {
      message,
      error,
    },
  };
};

export const issueTaxInvoiceReset = (): actionTypes.IssueTaxInvoiceResetAction => {
  return {
    type: actionTypes.ISSUE_TAX_INVOICE_RESET,
  };
};

export const cancelTaxInvoiceRequest = (payload: actionTypes.CancelTaxInvoiceRequest): actionTypes.CancelTaxInvoiceRequestAction => {
  return {
    type: actionTypes.CANCEL_TAX_INVOICE_REQUEST,
    payload,
  };
};

export const cancelTaxInvoiceSuccess = (payload: actionTypes.CancelTaxInvoiceResponse): actionTypes.CancelTaxInvoiceSuccessAction => {
  return {
    type: actionTypes.CANCEL_TAX_INVOICE_SUCCESS,
    payload,
  };
};

export const cancelTaxInvoiceError = (message: string, error?: any): actionTypes.CancelTaxInvoiceErrorAction => {
  return {
    type: actionTypes.CANCEL_TAX_INVOICE_ERROR,
    payload: {
      message,
      error,
    },
  };
};

export const cancelTaxInvoiceReset = (): actionTypes.CancelTaxInvoiceResetAction => {
  return {
    type: actionTypes.CANCEL_TAX_INVOICE_RESET,
  };
};

export const updateTaxInvoiceRequest = (payload: actionTypes.UpdateTaxInvoiceRequest): actionTypes.UpdateTaxInvoiceRequestAction => {
  return {
    type: actionTypes.UPDATE_TAX_INVOICE_REQUEST,
    payload,
  };
};

export const updateTaxInvoiceSuccess = (payload: actionTypes.UpdateTaxInvoiceResponse): actionTypes.UpdateTaxInvoiceSuccessAction => {
  return {
    type: actionTypes.UPDATE_TAX_INVOICE_SUCCESS,
    payload,
  };
};

export const updateTaxInvoiceError = (message: string, error?: any): actionTypes.UpdateTaxInvoiceErrorAction => {
  return {
    type: actionTypes.UPDATE_TAX_INVOICE_ERROR,
    payload: {
      message,
      error,
    },
  };
};

export const updateTaxInvoiceReset = (): actionTypes.UpdateTaxInvoiceResetAction => {
  return {
    type: actionTypes.UPDATE_TAX_INVOICE_RESET,
  };
};

export const getActiveTaxInvoicesRequest = (payload: actionTypes.GetActiveTaxInvoicesRequest): actionTypes.GetActiveTaxInvoicesRequestAction => {
  return {
    type: actionTypes.GET_ACTIVE_TAX_INVOICES_REQUEST,
    payload,
  };
};

export const getActiveTaxInvoicesSuccess = (payload: actionTypes.GetActiveTaxInvoicesResponse): actionTypes.GetActiveTaxInvoicesSuccessAction => {
  return {
    type: actionTypes.GET_ACTIVE_TAX_INVOICES_SUCCESS,
    payload,
  };
};

export const getActiveTaxInvoicesError = (message: string, error?: any): actionTypes.GetActiveTaxInvoicesErrorAction => {
  return {
    type: actionTypes.GET_ACTIVE_TAX_INVOICES_ERROR,
    payload: {
      message,
      error,
    },
  };
};

export const getActiveTaxInvoicesReset = (): actionTypes.GetActiveTaxInvoicesResetAction => {
  return {
    type: actionTypes.GET_ACTIVE_TAX_INVOICES_RESET,
  };
};

export const verifyCreditNoteRequest = (payload: actionTypes.VerifyCreditNoteRequest): actionTypes.VerifyCreditNoteRequestAction => {
  return {
    type: actionTypes.VERIFY_CREDIT_NOTE_REQUEST,
    payload,
  };
};

export const verifyCreditNoteSuccess = (payload: actionTypes.GetVatInfoResponse): actionTypes.VerifyCreditNoteSuccessAction => {
  return {
    type: actionTypes.VERIFY_CREDIT_NOTE_SUCCESS,
    payload,
  };
};

export const verifyCreditNoteError = (message: string, error?: any): actionTypes.VerifyCreditNoteErrorAction => {
  return {
    type: actionTypes.VERIFY_CREDIT_NOTE_ERROR,
    payload: {
      message,
      error,
    },
  };
};

export const verifyCreditNoteReset = (): actionTypes.VerifyCreditNoteResetAction => {
  return {
    type: actionTypes.VERIFY_CREDIT_NOTE_RESET,
  };
};

